import { Alert } from "react-bootstrap";
import { PrimaryButton } from "components/Button/style";
import { IAlertaLote } from "../types";

interface AlertaLoteProps {
  alerta: IAlertaLote;
  onCancelar: () => void;
  onConfirmar: () => void;
}

export function AlertaLote({ alerta, onCancelar, onConfirmar }: AlertaLoteProps) {
  return (
    <>
      <Alert variant="warning">
        <strong>Atenção:</strong> Placa <strong>{alerta.placa}</strong> já está na estampagem #{alerta.idLote} ({alerta.nomeEmpresa}). Deseja continuar?
      </Alert>
      <div className="d-flex gap-2">
        <PrimaryButton outline variante="primary" onClick={onCancelar}>Cancelar</PrimaryButton>
        <PrimaryButton onClick={onConfirmar}>Confirmar mesmo assim</PrimaryButton>
      </div>
    </>
  );
}
